import { Outlet } from 'react-router-dom'

import { Admin, Auth } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'

const admin = [
    {
        path: 'admin',
        element: <Auth guard="admin" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'admin',
        element: <Admin guard="admin" />,
        children: [
            { path: '', element: <Lazy view="Admin/Dashboard" /> },
            { path: 'profile', element: <Lazy view="Admin/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },
            { path: 'login-history', element: <Lazy view="Admin/Dashboard/LoginHistory" title="Login History" /> },
            { path: 'setting', element: <Lazy view="Admin/Dashboard/Setting" title="Setting" /> },
            {
                path: 'admins',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Admins/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Admins/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Admins/Create" title="Edit" /> },
                ],
            },
            {
                path: 'roles',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Roles/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Roles/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Roles/Create" title="Edit" /> },
                ],
            },
            {
                path: 'users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Users/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Users/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Users/Create" title="Edit" /> },
                ],
            },
            {
                path: 'customers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Customers/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Customers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Customers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'service-staffs',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/ServiceStaffs/List" /> },
                    { path: 'create', element: <Lazy view="Admin/ServiceStaffs/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/ServiceStaffs/Create" title="Edit" /> },
                ],
            },
            {
                path: 'stores',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Stores/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Stores/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Stores/Create" title="Edit" /> },
                ],
            },
            { path: 'order-requests', element: <Lazy view="Admin/OrderRequests/List" /> },
            {
                path: 'orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Orders/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Orders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Orders/Create" title="Edit" /> },
                    { path: ':id', element: <Lazy view="Admin/Orders/View" title="View" /> },
                ],
            },
            { path: 'order-progress', element: <Lazy view="Admin/OrderProgress/List" /> },
            {
                path: 'warranty-services',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/WarrantyServices/List" /> },
                    { path: ':id', element: <Lazy view="Admin/WarrantyServices/View" title="View" /> },
                ],
            },
            {
                path: 'customer-requests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/CustomerRequests/List" /> },
                    { path: ':id', element: <Lazy view="Admin/CustomerRequests/View" title="View" /> },
                ],
            },
            { path: 'wallets', element: <Lazy view="Admin/Wallets/List" /> },
            {
                path: 'withdrawal-requests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/WithdrawalRequests/List" /> },
                    { path: ':id', element: <Lazy view="Admin/WithdrawalRequests/View" title="View" /> },
                ],
            },
            {
                path: 'machine-types',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/MachineTypes/List" /> },
                    { path: 'create', element: <Lazy view="Admin/MachineTypes/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/MachineTypes/Create" title="Edit" /> },
                ],
            },
            {
                path: 'machines',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Machines/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Machines/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Machines/Create" title="Edit" /> },
                ],
            },
            {
                path: 'terms',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Terms/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Terms/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Terms/Create" title="Edit" /> },
                ],
            },
            {
                path: 'festival-offers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/FestivalOffers/List" /> },
                    { path: 'create', element: <Lazy view="Admin/FestivalOffers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/FestivalOffers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'service-inspections',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/ServiceInspection/List" /> },
                    { path: 'create', element: <Lazy view="Admin/ServiceInspection/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/ServiceInspection/Create" title="Edit" /> },
                ],
            },
            {
                path: 'machine-demos',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/MachineDemo/List" /> },
                    { path: 'create', element: <Lazy view="Admin/MachineDemo/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/MachineDemo/Create" title="Edit" /> },
                ],
            },
        ],
    },
]

export default admin
